/*=========================================================================================
  File Name: moduleNotificationsMutations.js
  Description: Notifications Module Mutations
==========================================================================================*/
import _ from "lodash";
export default {
	SET_MISSIONS(state, missions) {
		state.missions = missions;
	},
	SET_TOTAL_MISSIONS(state, total) {
		state.total = total;
	},
	ADD_NEW_MISSION(state, mission) {
		state.missions.unshift(mission);
		state.total = state.total + 1;
	},
	UPDATE_MISSION(state, mission) {
		const idx = _.findIndex(state.missions, { id: mission.id });
		if (idx !== -1) {
			Object.assign(state.missions[idx], mission);
		}
	},
	ADD_NEW_AUDIO(state, audio) {
		state.audios.push(audio);
	},
	DELETE_AUDIO(state, todoId) {
		const findInPlayedAudios = _.findIndex(state.playedAudios, { todoId: todoId });
		const currentIdx = _.findIndex(state.audios, { todoId: todoId });
		if (findInPlayedAudios === -1) {
			if (currentIdx !== -1) {
				state.playedAudios.push(_.cloneDeep(state.audios[currentIdx]));
			}
		} else {
			if (currentIdx !== -1) {
				state.playedAudios[findInPlayedAudios] = state.audios[currentIdx];
			}
		}
		state.audios.splice(currentIdx, 1);
	},
	RESET_LIST_AUDIO(state, payload) {
		state.audios = payload.audios;
		state.playedAudios = payload.playedAudios;
	},
	INDEX_UPDATE(state, indexUpdate) {
		state.indexUpdate = indexUpdate;
	},
	RESET_LIST_AUDIO_AN_HOUR(state) {
		state.audios = [...state.audios, ...state.playedAudios];
		state.playedAudios = [];
	},
	DELETE_MISSION(state, mission) {
		const currentIdx = _.findIndex(state.missions, { id: mission.id });
		state.missions.splice(currentIdx, 1);
	}
};
